<template>
  <button
    class="flex items-center rounded-xl font-light"
    @click="locationStore.showLocationDialog = true"
  >
    <IconMap class="mr-2 inline h-8" />
    <Transition
      name="fade"
      mode="out-in"
    >
      <span
        v-if="currentReceptionWay?.type === 'delivery'"
        class="flex items-center gap-2"
      >
        <span>{{ transformAddress(currentReceptionWay) }}</span>
        <span
          v-if="locationStore.canDeliver != null"
          class=""
          >|</span
        >
        <span
          v-if="locationStore.canDeliver === true"
          class="text-[#999700]"
          >~ {{ user?.delivery_duration + " мин" || 'Нет данных' }}</span
        >
        <span v-else-if="locationStore.canDeliver === false">
          <IconDangerTriangle class="inline" />
        </span>
      </span>
      <span v-else-if="currentReceptionWay?.type === 'restaurant'">
        <span>{{ currentReceptionWay.name }}</span>
        <span class="mx-2">|</span>
        <span class="text-[#999700]">~ {{ user?.delivery_duration + " мин" || 'Нет данных' }}</span>
      </span>
      <span v-else>Выберите адрес</span>
    </Transition>
  </button>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useLocationStore } from '~/store/location'
import { nthIndex } from '~/utils'
import type { Address } from '~/interfaces/main'
import { useUser } from '~/composables/api/user'

const props = defineProps<{
    showDialog?: boolean
}>()
const isModalOpen = ref(props.showDialog)

const { data: currentReceptionWay } = useCurrentReceptionWay()
const { data: timeDeliver } = useMain(v => v.time_deliver)
const {data: user} = useUser((v) => v)

const locationStore = useLocationStore()


const transformAddress = (address: Address) => {
    let street = address.street

    if (street.length < 1) {
        if (address.district.length > 0) {
            street = address.district
        } else {
            street = address.city
        }
    }

  return street+", "+address.house
}
/*
const transformAddress = (address: string) => {
  let count = 0
  for (let i = 0; i < address.length; ++i) {
    if (address[i] === ',') count++
  }
  return address.slice(nthIndex(address, ',', Math.max(2, count - 1)) + 1).trim()
}*/

const closeModal = () => (locationStore.showLocationDialog = false)
</script>
